import axios from "axios";
import { BASE_URL } from "./ApiConstants";

export const fetchDataFromApi = async (url) => {
  const token = localStorage.getItem("token");
  const params = {
    headers: {
      Authorization: token,
    },
  };
  try {
    const { data } = await axios.get(BASE_URL + url, params);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const sendDataToApi = async (url, param) => {
  try {
    const token = localStorage.getItem("token");
    const headers = {
      headers: {
        Authorization: token,
      },
    };
    const { data } = await axios.post(BASE_URL + url, param, headers);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};
